module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/waste-glass-bottle2/font/notokr-bold.woff
// module id = ytX3
// module chunks = 0